export default __webpack_public_path__ + "static/media/item8.ad216cca.jpeg";